import React from "react";

import { PrimaryButton } from "../../simple-buttons/simple-buttons";
import { SVGSuccessIcon } from "../../svg-animated/svg-animated";
import { FormContext } from "../../forms";
import DocumentStatus from "./document-status";

const DocumentVerified = ({ context, verifyJourney }: {
    context?: FormContext,
    verifyJourney: () => void
}) => {
    return (
        <DocumentStatus
            icon={<SVGSuccessIcon />}
            headingText="All is looking good"
            subheadingText="You can continue with your application 
            and tap **Submit** when you&apos;re done."
            button={<PrimaryButton onClick={() => {
                verifyJourney();
                context?.gotoNextPage();
            }} text="Continue" />}
        />
    )
};

export default DocumentVerified;
